const playerProfilePalette = {
  playerPerformance: ['#07F7A9', '#06CD90'],
  teamBonus: ['#8EA5C2', '#B1C5DD'],
  penalties: ['#FF8282', '#FF4F4F'],
}

export default playerProfilePalette
